import { Loader2, MailOpen, ShieldAlert } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import { useMailTest } from "../hooks/useMailTest";

export function MailTestPanel() {
  const {
    to,
    setTo,
    status,
    checking,
    sending,
    message,
    messageTone,
    checkStatus,
    sendTest,
  } = useMailTest();

  return (
    <section className="rounded-lg border border-border bg-card p-4">
      <div className="grid gap-3 xl:grid-cols-[minmax(0,1fr)_minmax(240px,320px)_auto_auto] xl:items-end">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-wide text-brand-gold-dark">
            SMTP
          </p>
          <h2 className="mt-1 text-sm font-semibold text-foreground">Test d'envoi email</h2>
          <p className="mt-1 text-xs text-muted-foreground">
            Vérifie la configuration Gmail/SMTP avant de brancher les envois automatiques.
          </p>
          {status && (
            <p className="mt-2 text-[11px] text-muted-foreground">
              {status.host ?? "SMTP non configuré"}:{status.port} - {status.from ?? "expéditeur manquant"}
            </p>
          )}
        </div>

        <Input
          value={to}
          onChange={(event) => setTo(event.target.value)}
          placeholder="Adresse de test"
          type="email"
        />

        <Button type="button" variant="secondary" onClick={checkStatus} disabled={checking}>
          {checking ? <Loader2 size={13} className="animate-spin" /> : <ShieldAlert size={13} />}
          Vérifier
        </Button>

        <Button type="button" onClick={sendTest} disabled={sending || !to.trim()}>
          {sending ? <Loader2 size={13} className="animate-spin" /> : <MailOpen size={13} />}
          Envoyer
        </Button>
      </div>

      {message && (
        <div
          className={cn(
            "mt-3 border px-3 py-2 text-[12px]",
            messageTone === "success" && "border-success-border bg-success-bg text-success-text",
            messageTone === "warning" && "border-warning-border bg-warning-bg text-warning-text",
            messageTone === "danger" && "border-danger-border bg-danger-bg text-danger-text",
          )}
        >
          {message}
        </div>
      )}
    </section>
  );
}
